import t from "../../../../helpers/t";
import React, { useState } from "react";
import ImageViewer from "../../../../components/imgView/ImageView";

const DescriptionAndImages = (props) => {
  const [currentImage, setCurrentImage] = useState("");
  let descriptionHtml = props["descriptionHtml"];
  let splitObject = props["splitObject"];
  let task = props["task"];
  let onChangeForm = props["onChangeForm"];
  let images = null;
  if (typeof task["images"] !== "undefined") {
    images = task["images"];
  }
  return (
    <>
      <div className="inb-form-group column medium-12 small-12 external_note">
        <label className="inb-form__controlLabel">{t("description")}</label>
        <div className="inb-form__controllClass">
          {descriptionHtml === "" && (
            <textarea
              className="form-control "
              name="description"
              value={task.description}
              maxLength="4000"
              placeholder=""
              onChange={onChangeForm}
              readOnly={task.readonly}
              style={{ resize: "none" }}
            >
              {" "}
            </textarea>
          )}
          {descriptionHtml !== "" && (
            <>
              {splitObject.map((question) => {
                const { valueSelect, answers } = question;
                return (
                  <>
                    <p>
                      <b>{question["question"]}</b>
                    </p>
                    {answers !== null && Array.isArray(answers) && (
                      <>
                        {valueSelect !== null &&
                          answers.map((answer) => {
                            return (
                              <>
                                {answer["key"] === valueSelect && (
                                  <p style={{ paddingLeft: "10px" }}>{answer["value"]}</p>
                                )}
                              </>
                            );
                          })}
                      </>
                    )}
                    {valueSelect !== null && answers === null && (
                      <p style={{ paddingLeft: "10px" }}>{valueSelect}</p>
                    )}

                    <p>&nbsp;</p>
                  </>
                );
              })}
            </>
          )}
        </div>
        <div>
          {images !== null && (
            <span
              style={{
                fontSize: "0.8em",
                display: "block",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              {t("annotated_images", null, "capital")}:
            </span>
          )}
          {images !== null &&
            typeof images.map === "function" &&
            images.map((image, index) => {
              const img = image["image"];
              return (
                <img
                  src={img}
                  style={{
                    width: "150px",
                    height: "150px",
                    display: "inline-block",
                    marginLeft: "10px",
                    cursor: "pointer",
                    marginBottom: "10px",
                  }}
                  alt={""}
                  key={index + image}
                  onClick={() => {
                    setCurrentImage(img);
                  }}
                />
              );
            })}
          {currentImage !== "" && (
            <ImageViewer
              images={images.map((image) => image["image"])}
              currentImage={currentImage}
              setCurrentImage={setCurrentImage}
              dispatch={props.dispatch}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default DescriptionAndImages;
